import { render, staticRenderFns } from "./UserBillList.vue?vue&type=template&id=94a1840a&scoped=true&"
import script from "./UserBillList.vue?vue&type=script&lang=js&"
export * from "./UserBillList.vue?vue&type=script&lang=js&"
import style0 from "./UserBillList.vue?vue&type=style&index=0&id=94a1840a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a1840a",
  null
  
)

export default component.exports